module.exports = __webpack_public_path__ + "img/Superman poster.bc31aed8.png";